import background from "../../assets/images/background.png";
import { HOME_ROUTE } from "../../routes";
import { Link } from "react-router-dom";

const PageNotFound = () => {

    return ( 
        <div id="sucess-page" style={{
            backgroundImage: `url(${background})`,
            minHeight: "100vh",
        }}>
            <div className="container pb-5">
                <div className="btn mt-3">
                    
                </div>
                <h1 className="text-center text-light mt-5">404 Page Not Found</h1>
                <div className="text-center mt-3">
                    <Link className="text-center text-light mt-5" to={HOME_ROUTE}>Go to Home</Link>
                </div>
            </div>
        </div> 
    );
}
 
export default PageNotFound;